import flowRight from 'lodash/flowRight'
import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Box from 'shared/components/Box'
import withDialog from 'shared/hocs/withDialog'
import { hideAllDialogs } from 'shared/redux/app/reducer'
import styled from 'styled-components'
import SelectionControlGroup from 'shared/components/SelectionGroupControl'
import Button from 'shared/components/Button'

type Options = {
  label: string
  value: string
}

type SnackbarProps = {
  onCancel: Function
  onApply: Function
  sortByValue: string
  notesValue: string
  options: Options[]
}

function NoteFilter(props: SnackbarProps) {
  const { onApply, sortByValue, notesValue, options, onCancel } = props
  const [sortByVal, setSortByVal] = useState<string>(sortByValue)
  const [notesVal, setNotesVal] = useState<string>(notesValue)
  const dispatch = useDispatch()

  const applyFilter = useCallback(() => {
    onApply({ sortByValue: sortByVal, notesValue: notesVal })
  }, [onApply, sortByVal, notesVal])

  return (
    <NoteFiltersContainer>
      <FiltersContainer>
        <FilterSubContainer>
          <FilterTitle>View Notes</FilterTitle>
          <SelectionControlGroup
            id="view"
            name="view"
            direction="column"
            controls={options}
            value={notesVal}
            onChange={val => setNotesVal(val)}
            type="radio"
          />
        </FilterSubContainer>
        <FilterSubContainer>
          <FilterTitle>Sort By</FilterTitle>
          <SelectionControlGroup
            id="filter_id"
            name="filter_id"
            direction="column"
            controls={[
              {
                label: 'Newest to Oldest',
                value: 'desc',
              },
              {
                label: 'Oldest to Newest',
                value: 'asc',
              },
            ]}
            value={sortByVal}
            onChange={val => setSortByVal(val)}
            type="radio"
          />
        </FilterSubContainer>
      </FiltersContainer>

      <ActionButtonsContainer>
        <Button
          variant="outline-primary"
          size="large"
          width="140px"
          onClick={() => {
            if (onCancel) onCancel()
            else dispatch(hideAllDialogs())
          }}
        >
          Close
        </Button>
        <Button
          variant="primary"
          size="large"
          width="180px"
          onClick={() => {
            applyFilter()
          }}
        >
          Apply Filter
        </Button>
      </ActionButtonsContainer>
    </NoteFiltersContainer>
  )
}

const NoteFiltersContainer = styled(Box)`
  padding: 50px 30px 10px 30px;
`

const FilterTitle = styled(Box)`
  font-weight: bold;
  opacity: 0.9;
  margin-bottom: 20px;
`

const FiltersContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  margin-bottom: 60px;
`

const FilterSubContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

const ActionButtonsContainer = styled(Box)`
  display: flex;
  justify-content: center;

  button {
    &:nth-child(2) {
      margin-left: 30px;
    }
  }
`

const AdvancedFiltersDialog = flowRight(withDialog())(NoteFilter)

AdvancedFiltersDialog.defaultProps = {
  hasCancel: false,
  hasContinue: false,
  footerClassName: 'dialog__footer--less-padding',
}

export default AdvancedFiltersDialog
